export function dataInRequest(params = {}) {
  return {
    type: '@mensagemSistemaOperacaoAgricola/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@mensagemSistemaOperacaoAgricola/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@mensagemSistemaOperacaoAgricola/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@mensagemSistemaOperacaoAgricola/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@mensagemSistemaOperacaoAgricola/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@mensagemSistemaOperacaoAgricola/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@mensagemSistemaOperacaoAgricola/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@mensagemSistemaOperacaoAgricola/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@mensagemSistemaOperacaoAgricola/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@mensagemSistemaOperacaoAgricola/RECORD_FILTERING',
    payload: { params },
  };
}
